import { useEffect, useId, useState } from "react";
import { t, useStoreLanguage } from "../../../features/store-language/i18n.ts";
import { agencySessionKey, isCompanySalesAgent } from "../../../utils/agencySession.ts";
import { salesAgentAgencies } from "../Auth/salesAgentService.ts";
import type { AgencyChoice } from "../Auth/agencyIdentityService.ts";
import { AccountButton, AccountSelect } from "../../shared/account/AccountUI.tsx";
import { PendingRing } from "../../shared/LoadingRing.jsx";
import AppFeedback from "../../shared/AppFeedback.tsx";
import "./StoreTextField.css";

export default function OrderAgencyField({ value, onChange, disabled }: {
  value?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  useStoreLanguage();
  const id = useId();
  const companyAgent = isCompanySalesAgent();
  const session = agencySessionKey();
  const [choices, setChoices] = useState<AgencyChoice[]>([]);
  const [loading, setLoading] = useState(companyAgent);
  const [failed, setFailed] = useState(false);
  const [revision, setRevision] = useState(0);
  useEffect(function () {
    if (!companyAgent) return;
    let active = true;
    setLoading(true);
    setFailed(false);
    salesAgentAgencies().then(function (result) {
      if (active && session === agencySessionKey()) setChoices(result);
    }).catch(function (error) {
      if (active && session === agencySessionKey()) {
        setFailed(true);
        AppFeedback.httpError(error);
      }
    }).finally(function () { if (active) setLoading(false); });
    return function () { active = false; };
  }, [companyAgent, session, revision]);
  if (!companyAgent) return null;
  return (
    <div className="store-text-field">
      <label htmlFor={id}>{t("نام نماینده")}</label>
      <AccountSelect<number>
        id={id}
        aria-required
        aria-busy={loading}
        placeholder={t("نمایندگی را انتخاب کنید.")}
        value={value}
        disabled={disabled || loading || failed}
        suffixIcon={loading ? <PendingRing /> : undefined}
        showSearch
        getPopupContainer={function (trigger) { return trigger.parentElement!; }}
        optionFilterProp="label"
        options={choices.map(function (choice) {
          return { value: choice.salesAgencyId, label: choice.title };
        })}
        onChange={onChange}
      />
      {failed ? (
        <AccountButton
          disabled={disabled}
          loading={loading}
          onClick={function () { setRevision(function (current) { return current + 1; }); }}
        >
          {t("تلاش مجدد")}
        </AccountButton>
      ) : null}
    </div>
  );
}
